import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import saveIcon from "../../../icons/common/save.png";
import closeIcon from "../../../icons/common/close.png";
import activeIcon from "../../../icons/common/active.png";
import inactiveIcon from "../../../icons/common/inactive.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLlAdminEndPoint, updateLlAdminEndPoint } from "../utils";
import axios from "axios";
import { setRowData } from "../../grid/gridReducer";
import { setLanguageData } from "../lladminreducer";
import notify from "../../../services/toasterService";
import { RootState } from "../../../redux/store";

const PreviewLanguage = () => {
  const dispatch = useDispatch();
  const [languageInfo, setLanguageInfo] = useState<any[]>([]);

  /* Get selected data from Grid Reducer */
  const selRowData = useSelector(
    (state: RootState) => state.gridReducer.selectedRowData
  );
  // console.log(selectedRowData, 'selectedRowData');

  useEffect(() => {
    if (selRowData && selRowData?.length > 0) {
      setLanguageInfo(selRowData);
    }
    // Write for onload
  }, [selRowData]);

  const languageFieldFocusOut = (value: any, key: any) => {
    setLanguageInfo([{ ...languageInfo[0], [key]: value }]);
  };

  /**
   * Changing status for Preview selected tabs
   * @param flag - true/false
   */
  const changeStatusForRowData = (flag: any) => {
    if (flag === false) {
      setLanguageInfo([{ ...languageInfo[0], activeForGrid: "Inactive" }]);
    } else {
      setLanguageInfo([{ ...languageInfo[0], activeForGrid: "Active" }]);
    }
  };

  const clearPreview = () => {
    dispatch(setRowData([]));
  };

  /**
   * PUT web service methods for Location setting tabs
   * @param data - Tab Name
   */
  const updateLocationSettingTabApi = async (data: any) => {
    console.log(data);
    const endPointURL = updateLlAdminEndPoint(data.tabApiName, data.id);
    let body = {
      country: data.country,
      deleted: data.deleted,
      id: data.id,
      isoLongCode: data.isoLongCode,
      isoShortCode: data.isoShortCode,
      language: data.language,
      languageDescription: data.description,
      organizationId: data.organizationId,
      tenantId: data.tenantId,
    };
    const status = data.activeForGrid.toLowerCase();
    if (status === "active") {
      Object.assign(body, { active: true });
    } else {
      Object.assign(body, { active: false });
    }
    await axios
      .put(endPointURL, body)
      .then((res: any) => {
        console.log(res);
        setLanguageInfo(res.data);
        notify("Language updated successfully", "success");
        getlAdminTabs(data.tabApiName);
      })
      .catch((err) => {
        notify("Failed to update language", "error");
      });
  };

  const getlAdminTabs = async (tabName: any) => {
    const endPointURL = getLlAdminEndPoint(tabName);
    await axios
      .get(endPointURL)
      .then((res: any) => {
        dispatch(setLanguageData(res.data));
        const dataa = res.data[0];
        setLanguageInfo(dataa);
        setTimeout(() => {
          dispatch(setRowData(languageInfo));
        }, 10);
      })
      .catch((err) => {
        notify("Failed to get languages", "error");
      });
  };

  const footerPreview = (data: any) => {
    return (
      <div className="col-sm-12 px-0 pt-5 ">
        <div className="col-sm-6 col-md-6 col-lg-6 pl-1.5rem pr-1 preview-Key  ">
          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left"
            onClick={() => updateLocationSettingTabApi(data)}
          >
            <img src={saveIcon} alt="Save" />
          </ButtonComponent>

          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left ml-3"
            onClick={() => clearPreview()}
          >
            <img src={closeIcon} alt="Close" />
          </ButtonComponent>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 preview-value pt-3">
          <p className="preview-status">
            {data?.activeForGrid === "Active" ||
            data?.activeForGrid === "active" ? (
              <span>
                <img
                  src={activeIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(false)}
                />
                &nbsp; &nbsp; Active
              </span>
            ) : (
              <span>
                <img
                  src={inactiveIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(true)}
                />
                &nbsp; &nbsp; Inactive
              </span>
            )}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div>
      {languageInfo && languageInfo.length > 0 ? (
        <div className="col-sm-12 px-3 py-3 preview-details">
          <div className="col-sm-12 px-0 pt-4 ">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key" style={{lineHeight: '18px'}}>ID</div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {languageInfo[0].id}
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key" style={{lineHeight: '33px'}}>
              Language
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={languageInfo[0].language}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => languageFieldFocusOut(e, 'language')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={languageInfo[0]?.language}
                onChange={(e: any) =>
                  languageFieldFocusOut(e.target.value, "language")
                }
              />
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{lineHeight: '33px'}}>
              Description
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={languageInfo[0].description}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => languageFieldFocusOut(e, 'description')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={languageInfo[0]?.description}
                onChange={(e: any) =>
                  languageFieldFocusOut(e.target.value, "description")
                }
              />
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{lineHeight: '33px'}}>
              ISO Short Code
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={languageInfo[0].isoShortCode}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => languageFieldFocusOut(e, 'isoShortCode')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={languageInfo[0]?.isoShortCode}
                onChange={(e: any) =>
                  languageFieldFocusOut(e.target.value, "isoShortCode")
                }
              />
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{lineHeight: '33px'}}>
              ISO Long Code
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={languageInfo[0].isoLongCode}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => languageFieldFocusOut(e, 'isoLongCode')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={languageInfo[0]?.isoLongCode}
                onChange={(e: any) =>
                  languageFieldFocusOut(e.target.value, "isoLongCode")
                }
              />
            </div>
          </div>

          <div className="col-sm-12 px-0 pt-5 pb-4">
            {footerPreview(languageInfo[0])}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default PreviewLanguage;
